import { SUPPORT_CONTACT_USER_IDS } from "@core/constants/core.constants";
import { ENotificationBannerTheme, ENotificationId } from "@core/enums/notification.enum";
import { ICurrentUser } from "@core/interfaces/current-user.interface";

export interface INotificationBannerConfig {
    id: ENotificationId;
    theme: ENotificationBannerTheme;
    text: string;
    shouldShow: (user: ICurrentUser) => boolean;
}

export const NOTIFICATION_BANNERS: readonly INotificationBannerConfig[] = [
    {
        id: ENotificationId.SupportContact,
        theme: ENotificationBannerTheme.Alert,
        text: "Мы обнаружили, что связь с вашим партнёром прервалась. Чтобы сохранить для вас гарантии и продолжить сотрудничество, пожалуйста, свяжитесь с нами через кнопку «Связаться с нами»",
        shouldShow: (user: ICurrentUser): boolean =>
            user.isBatrak && SUPPORT_CONTACT_USER_IDS.has(user.userId),
    },
];
